export const BASE_APP_URL =
  process.env.BASE_APP_URL || 'https://app.sidecarhealth.com'
export const BASE_SITE_URL =
  process.env.BASE_SITE_URL || 'https://sidecarhealth.com'
export const BASE_TOOLTIP_URL =
  process.env.BASE_TOOLTIP_URL || 'https://tooltips.sidecarhealth.com'
export const BASE_PARTNER_URL =
  process.env.BASE_PARTNER_URL || 'https://partner.sidecarhealth.com'
